import { render } from "./VabenePageStudioPage.vue?vue&type=template&id=38dfa3c2&scoped=true&ts=true"
import script from "./VabenePageStudioPage.vue?vue&type=script&lang=ts"
export * from "./VabenePageStudioPage.vue?vue&type=script&lang=ts"

import "./VabenePageStudioPage.vue?vue&type=style&index=0&id=38dfa3c2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38dfa3c2"]])

export default __exports__